var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUk(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 10,
    viewBox: "0 0 13 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0.617188H11.8349V9.49338H0V0.617188Z",
    fill: "#41479B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8349 8.33764L7.45847 5.05529L11.8349 1.77294V0.617188H10.2939L5.91746 3.89954L1.541 0.617188H0V1.77294L4.37646 5.05529L0 8.33764V9.49338H1.54103L5.91746 6.21104L10.2939 9.49338H11.8349V8.33764Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.81796e-06 0.617188L0 0.61719V1.0795L5.30106 5.05529L0 9.03109V9.49339L0.221906 9.78927L5.91746 5.5176L11.613 9.78927L12.0568 9.19752L6.53386 5.05529L12.0568 0.913065L11.8349 0.617188H11.2185L5.91746 4.59299L0.616395 0.617188H1.81796e-06Z",
    fill: "#DC251C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.4381 3.57592V0.617188H7.39683V3.57592H11.8349V6.53465H7.39683V9.49338H4.4381V6.53465H0V3.57592H4.4381Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.17778 4.3156V0.617188H6.65714V4.3156H11.8349V5.79496H6.65714V9.49338H5.17778V5.79496H0V4.3156H5.17778Z",
    fill: "#DC251C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUk);
export default __webpack_public_path__ + "static/media/UK.b7c739221ff09986f9c2de7fcabf3e9f.svg";
export { ForwardRef as ReactComponent };